"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AltiumPortGroupingRule = void 0;
const NetNamingRules_1 = require("../../../../NetCombobulation/NetNamingRules");
const project_1 = require("../../project");
class AltiumPortGroupingRule {
    constructor(config) {
        this.config = config;
        this.type = NetNamingRules_1.NetNamingRuleType.Group;
        if (this.config.mode !== project_1.HierarchyMode.Flat && this.config.mode !== project_1.HierarchyMode.Global) {
            throw new Error(`AltiumPortGroupingRule should only be used in Flat or Global mode. ` +
                `In hierarchical modes, ports bind through matching sheet entries.`);
        }
    }
    apply(manager, _hierarchy) {
        const groupsByPortKey = new Map();
        for (const group of manager.findGroupsWithLabel('port')) {
            for (const label of group.getNetLabels()) {
                const portKey = this.getProjectWidePortKey(label);
                if (!portKey) {
                    continue;
                }
                let groups = groupsByPortKey.get(portKey);
                if (!groups) {
                    groups = new Set();
                    groupsByPortKey.set(portKey, groups);
                }
                groups.add(group);
            }
        }
        for (const groups of groupsByPortKey.values()) {
            if (groups.size > 1) {
                const [target, ...toMerge] = groups;
                manager.mergeGroups(target, ...toMerge);
                for (const group of toMerge) {
                    for (const label of group.getNetLabels()) {
                        const portKey = this.getProjectWidePortKey(label);
                        if (portKey) {
                            groupsByPortKey.get(portKey)?.delete(group);
                        }
                    }
                }
                for (const label of target.getNetLabels()) {
                    const portKey = this.getProjectWidePortKey(label);
                    if (portKey) {
                        groupsByPortKey.get(portKey)?.add(target);
                    }
                }
            }
        }
        return manager;
    }
    getProjectWidePortKey(label) {
        if (label.labelType !== 'port' || label.strategyMetadata?.harness?.isCarrier) {
            return undefined;
        }
        const portName = label.strategyMetadata?.['port-metadata']?.portName?.toLowerCase();
        if (!portName) {
            return undefined;
        }
        const harness = label.strategyMetadata?.harness;
        if (harness?.harnessSource !== 'synthetic-port') {
            return `plain:${portName}`;
        }
        const memberName = harness.harnessMemberName?.toLowerCase();
        return memberName ? `synthetic:${portName}\u0000${memberName}` : undefined;
    }
}
exports.AltiumPortGroupingRule = AltiumPortGroupingRule;
//# sourceMappingURL=AltiumPortGroupingRule.js.map